import React from "react";
import { modalVariants } from "../../../frameMotinVariats/frameMotionVariants";
import { useAppDispatch } from "../../../store/hooks";
import { startGame, setCPULevel } from "../../../store/gameSlice";
import { setModal, toggleModal } from "../../../store/modalSlice";
import { useNavigate } from "react-router-dom";

import {
  Header,
  DifficultyList,
  DifficultyItem,
  DifficultyWrapper,
  CloseBtn,
} from "./DifficultyGameModalContentStyles";

const DifficaltyGameModalContent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const selectDifficulty = (level: number) => {
    dispatch(setCPULevel(level));
    dispatch(setModal({ modal: "mainMenu", status: false }));
    dispatch(startGame("CPUvP"));
    navigate("/game");
  };

  return (
    <DifficultyWrapper
      variants={modalVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <Header>Select difficulty</Header>
      <DifficultyList>
        <DifficultyItem variant="easy" onClick={() => selectDifficulty(2)}>
          Easy
        </DifficultyItem>
        <DifficultyItem variant="normal" onClick={() => selectDifficulty(6)}>
          Normal
        </DifficultyItem>
        <DifficultyItem variant="hard" onClick={() => selectDifficulty(8)}>
          Hard
        </DifficultyItem>
      </DifficultyList>
      <CloseBtn onClick={() => dispatch(toggleModal("mainMenu"))}>
        Back
      </CloseBtn>
    </DifficultyWrapper>
  );
};

export default DifficaltyGameModalContent;
